<template>
  <div class="home-node-gallery">
    <div class="row-heading">
      <slot></slot>
    </div>
    <div class="gallery-row">
      <NodeGalleryItem v-for="node in nodes" :node="node" :key="node.id"></NodeGalleryItem>
    </div>
  </div>
</template>
<script>
import NodeGalleryItem from '@/components/Home/NodeGalleryItem';

export default {
  name: 'NodeGallery',
  components: {NodeGalleryItem},
  props: {
    nodes: {
      type: Array,
      required: true
    }
  }
};
</script>
<style lang="postcss">
.home-node-gallery {
  @apply w-full;
  padding-left: 50px;
  padding-right: 50px;
  margin-bottom: 20px;

  .row-heading {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 900;
    font-size: 30px;
    line-height: 35px;
    display: flex;
    align-items: center;
    color: #000000;
    margin-bottom: 10px;
  }

  .gallery-row {
    @apply grid overflow-y-hidden overflow-x-auto justify-between;
    grid-template-columns: repeat(6, 180px);
    grid-gap: 20px;
    padding-bottom: 10px;
    min-height: 220px;
  }

  @media only screen and (min-width: 1300px) {
    .gallery-row {
      @apply overflow-visible;
    }
  }
}
</style>